.wrapper {
  flex-direction: column;
  height: 100%;
}

.content {
  flex-grow: 2;
  height: 100%;

  .grid {
    height: 100%;
    width: 100%;
  }

  .grid-view {
    min-height: 100%;
    align-items: stretch;
  }

  .grid-view::part(im-icon) {
    font-size: 24px;
    padding-bottom: 0;
    margin-top: 4px;
  }

  .header-buttons {
    padding-right: calc(2 * var(--spacer));
    margin-right: calc(2 * var(--spacer));
    position: relative;
    display: flex;

    &:not(:empty) {
      &:after {
        content: '';
        position: absolute;
        right: 0;
        top: 2px;
        height: 80%;
        width: 1px;
        background-color: var(--widget-border-color);
      }
    }

    .actions-button-content {
      display: flex;
      align-items: center;
      margin-right: -12px;

      .action-icon {
        font-size: 30px;
      }
    }
  }
}
